'use client'

import { RadioSingleSelect } from '@components/primitives/HtmlForm/RadioSingleSelect.client'
import { Text } from '@components/primitives/Text'
import { STRUCTURED_QUESTION_UNSURE } from './const'
import { debounceTrackQuestionModified } from './trackQuestionModified'
import type { ConditionCollectElementProps } from './types'

const debouncedEventTracking = debounceTrackQuestionModified('stageProgression')

export default function CollectStage({
  formRef,
  patientProfileData: { conditions, stageProgression },
  questionConfig,
}: ConditionCollectElementProps) {
  const condition = conditions[0] ?? 'condition'

  const updateHandler = (value: string) => {
    debouncedEventTracking(value)

    if (formRef && formRef.current) {
      formRef.current.requestSubmit()
    }
  }

  return (
    <div className='flex w-full flex-col gap-2'>
      <Text
        className='text-neutral900'
        element={'p'}
        styleName='h3'
        value={`What stage is your ${condition}?`}
      />
      <Text
        className='text-neutral900'
        element={'p'}
        styleName='p-small'
        value={
          'Why we ask: to provide you with more accurate recommendations of other relevant trials.'
        }
      />

      <div className='grid grid-cols-1 gap-2'>
        <RadioSingleSelect
          defaultValue={stageProgression[0]}
          name={questionConfig.id}
          onChange={updateHandler}
          options={DISEASE_STAGE_OPTIONS}
          required={!questionConfig.skippable}
        />
      </div>
    </div>
  )
}

const DISEASE_STAGE_OPTIONS = [
  {
    label: 'Stage I',
    value: '1',
  },
  {
    label: 'Stage II',
    value: '2',
  },
  {
    label: 'Stage III',
    value: '3',
  },
  {
    label: 'Stage IV',
    value: '4',
  },
  {
    label: STRUCTURED_QUESTION_UNSURE,
    value: STRUCTURED_QUESTION_UNSURE,
  },
]
